// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--a43d1e27e7309077287f"};